import colors from './colors';
import buttonVariants from '../components/Button/Button.styles';
import { formVariants } from '../components/Form';
import textVariants, { baseMonoStack, baseSansStack } from './text';
import { iconLinkVariants } from '../components/Icon/IconLink.styles';
import { statusChipVariants } from '../components/Status/StatusChip.styles';
import { statusDotVariants } from '../components/Status/StatusDot.styles';
import { filterBarVariants } from '../components/FilterBar/FilterBar';

// See https://rebassjs.org/theming
// See https://github.com/system-ui/theme-specification

const fourPointScale = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56, 64];

export type rebassThemeKey = any;
export type rebassProps = any;

export type Theme = {
  colors: rebassThemeKey;
  fonts: rebassThemeKey;
  fontSizes: rebassThemeKey;
  fontWeights: rebassThemeKey;
  lineHeights: rebassThemeKey;
  space: rebassThemeKey;
  sizes: rebassThemeKey;
  radii: rebassThemeKey;
  shadows: rebassThemeKey;
  text: rebassThemeKey;
  variants: rebassThemeKey;
  buttons: rebassThemeKey;
  forms: rebassThemeKey;
  filterBar: rebassThemeKey;
};

interface themeObject {
  [index: string]: rebassThemeKey;
}

const theme = {
  colors: colors,
  fonts: {
    root: baseSansStack,
    body: 'courier',
    heading: 'inherit',
    monospace: baseMonoStack,
  },
  fontSizes: [12, 14, 16, 20, 24, 32],
  fontWeights: {
    body: 400,
    heading: 700,
  },
  lineHeights: {
    interactive: 1.142857143,
    scale: [1, 1.25, 1.333333333, 1.5, 2],
  },
  space: fourPointScale,
  sizes: {
    scale: fourPointScale,
    full: '100%',
    vw: '100vw',
    vh: '100vh',
    headerHeight: fourPointScale[3],
    modalDefault: '650px',
    modalMin: '300px',
    modalMax: '750px',
  },
  radii: {
    none: 0,
    default: 8,
    heavy: 12,
    defaultNested: 6,
    circle: fourPointScale[4],
  },
  shadows: {
    zero: '0 4px 4px 0 rgba(0, 0, 0, 0)',
    m: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
    comment: '0 4px 6px 0 rgba(0, 0, 0, 0.1)',
    feature: '0 4px 6px 0 rgba(0, 0, 0, 0.125)',
    menu: '0 4px 4px 0 rgba(0, 0, 0, 0.125)',
    pressed: 'inset 0 0 8px 0 rgba(0, 0, 0, 0.20)',
    paymentMethod:
      '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)',
  },
  text: textVariants,
  variants: {
    ...iconLinkVariants,
    ...statusChipVariants,
    ...statusDotVariants,
  },
  buttons: buttonVariants,
  forms: formVariants,
  filterBar: filterBarVariants,
};

// @ts-ignore
theme.space.mainContent = theme.space[6];

export default theme;
export type { themeObject };
